<template>
  <div class="mt-24 flex justify-center md:mt-0">
    <RevContentBlock
      v-bind="contentBannerProps"
      :image-props="{
        alt: '',
        height: 239,
        src: '/img/buyback/no-result-illustration.svg',
        width: 423,
      }"
    >
      <span v-if="hasFilters" class="body-1">
        {{ description }}
      </span>
    </RevContentBlock>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from '#imports'
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContentBlock } from '@ds/components/ContentBlock'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './NoResults.translations'

const props = defineProps<{
  hasFilters: boolean
}>()
const i18n = useI18n()
const route = useRoute()

const description = computed(() =>
  props.hasFilters ? i18n(translations.description) : '',
)

const contentBannerProps = computed(() => {
  if (props.hasFilters) {
    const base = {
      surtitle: i18n(translations.surtitle),
      title: i18n(translations.emptyTitle),
    }

    if (route.name !== ROUTE_NAMES.BUYBACK.ORDERS.ALL) {
      return {
        ...base,
        buttonLabel: i18n(translations.searchButton),
        to: {
          name: ROUTE_NAMES.BUYBACK.ORDERS.ALL,
        },
      }
    }

    return base
  }

  return {
    surtitle: i18n(translations.surtitle),
    title: i18n(translations.emptyOrdersTitle),
  }
})
</script>
